<p-confirmDialog #cd [style]="{width: '450px'}" appendTo="body" [closable]="false" styleClass="custom-confirm-dialog">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3 w-full">
            <div class="flex align-items-center justify-content-center border-circle" style="width: 42px; height: 42px; background: #FEF2F2;">
                <i class="pi pi-trash text-red-500 text-xl"></i>
            </div>
            <span class="font-bold text-xl text-900">Delete Document?</span>
        </div>
    </ng-template>
    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column gap-2 mt-2 pl-1">
            <span class="text-700 font-medium line-height-3" style="font-size: 15px;">{{message.message}}</span>
            <span class="text-xs text-500">This action will permanently remove the document from your vault. This cannot be undone.</span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2 w-full pt-2">
            <button pButton pRipple label="Cancel" class="p-button-text p-button-plain font-bold text-gray-600" style="font-size: 14px;" (click)="cd.reject()"></button>
            <button pButton pRipple label="Delete Permanently" class="p-button-danger border-round-lg px-4 font-bold" style="background: #EF4444; border: none; font-size: 14px; height: 40px;" (click)="cd.accept()"></button>
        </div>
    </ng-template>
</p-confirmDialog>
<div class="mx-auto w-full flex flex-column lg:flex-row" style="margin-top: -2rem;">

    <!-- Desktop Sidebar (Hidden on Mobile/Tablet) -->
    <div class="hidden lg:block flex-shrink-0" style="width: 260px; position: sticky; top: 0; height: 100vh; align-self: flex-start;">
        <app-document-vault-sidebar #desktopSidebar 
            [activeCategoryId]="activeCategoryId" 
            [activeStatusFilter]="activeStatusFilter"
            (onCategorySelect)="handleCategorySelect($event)"
            (onStatusFilterSelect)="setStatusFilter($event)">
        </app-document-vault-sidebar>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-column gap-4 px-3 lg:px-0 lg:ml-5 lg:mr-1" style="min-width: 0; padding-top: 2rem; margin-right: 32px !important;">

        <!-- Header Section -->
        <div class="flex flex-column gap-4 w-full">
        <!-- Title and Buttons Row -->
        <div class="flex flex-column md:flex-row md:justify-content-between align-items-start md:align-items-center gap-4">
            <!-- Title -->
            <h1 class="m-0 font-bold" style="color: #2e04ac; font-size: 32px; letter-spacing: -0.5px;">
                <span style="position: relative; z-index: 1; font-size: 32px;">
                    Document
                    <span style="position: absolute; bottom: 3px; left: 0; right: 0; height: 6px; background-color: #ced029; z-index: -1;"></span>
                </span> 
                <span style="font-size: 32px;">Vault</span>
            </h1>

            <div class="align-self-end md:align-self-auto" style="padding: 4.43px; background: white; border-radius: 8.85px; outline: 1px #D7D7D7 solid; outline-offset: -1px; justify-content: flex-start; align-items: center; gap: 7.38px; display: inline-flex">
                <div class="action-btn-primary cursor-pointer" 
                     style="padding-left: 16.96px; padding-right: 16.96px; padding-top: 7.38px; padding-bottom: 7.38px; border-radius: 5.90px; justify-content: center; align-items: center; display: flex"
                     (click)="showUploadDialog(DocumentCategoryEnum.LOR, DocumentTypeEnum.Direct)">
                    <div style="text-align: center; justify-content: center; display: flex; flex-direction: column; font-size: 13px; font-weight: 600; word-wrap: break-word">Upload Document</div>
                </div>
                <div class="action-btn-secondary cursor-pointer" 
                     style="padding-left: 16.96px; padding-right: 16.96px; padding-top: 7.38px; padding-bottom: 7.38px; border-radius: 6.64px; justify-content: center; align-items: center; display: flex"
                     (click)="showUploadDialog(DocumentCategoryEnum.LOR, DocumentTypeEnum.Drive)">
                    <div style="text-align: center; justify-content: center; display: flex; flex-direction: column; font-size: 13px; font-weight: 600; word-wrap: break-word">Add Google Doc</div>
                </div>
            </div>
        </div>

        <!-- Banner Image -->
        <div class="w-full">
            <img src="assets/images/student-document-vault-banner.svg" alt="Document Repository Banner" class="w-full border-round-2xl" style="max-height: 220px; object-fit: cover;" />
        </div>

        <!-- Interactive Status Tabs -->
        <div class="flex w-full" style="background: #F5F5F5; border-radius: 12px; outline: 1px #DADADA solid; outline-offset: -1px; padding: 4px; height: 50px;">
            <div class="flex-1 flex justify-content-center align-items-center cursor-pointer transition-all transition-duration-300" 
                 [ngStyle]="{
                    'background': activeStatusFilter === 1 ? '#E0E0FF' : 'transparent',
                    'border-radius': '8px',
                    'color': activeStatusFilter === 1 ? '#000086' : '#6B7280',
                    'font-size': '15px',
                    'font-weight': activeStatusFilter === 1 ? '700' : '500',
                    'height': '100%',
                    'box-shadow': activeStatusFilter === 1 ? '0px 1px 2px rgba(0, 0, 134, 0.1)' : 'none'
                 }"
                 (click)="setStatusFilter(1)">
                All Documents ({{ statusCounts.all }})
            </div>
            <div class="flex-1 flex justify-content-center align-items-center cursor-pointer transition-all transition-duration-300" 
                 [ngStyle]="{
                    'background': activeStatusFilter === 2 ? '#E0E0FF' : 'transparent',
                    'border-radius': '8px',
                    'color': activeStatusFilter === 2 ? '#000086' : '#6B7280',
                    'font-size': '15px',
                    'font-weight': activeStatusFilter === 2 ? '700' : '500',
                    'height': '100%',
                    'box-shadow': activeStatusFilter === 2 ? '0px 1px 2px rgba(0, 0, 134, 0.1)' : 'none'
                 }"
                 (click)="setStatusFilter(2)">
                Uploaded ({{ statusCounts.uploaded }})
            </div>
            <div class="flex-1 flex justify-content-center align-items-center cursor-pointer transition-all transition-duration-300" 
                 [ngStyle]="{
                    'background': activeStatusFilter === 3 ? '#E0E0FF' : 'transparent',
                    'border-radius': '8px',
                    'color': activeStatusFilter === 3 ? '#000086' : '#6B7280',
                    'font-size': '15px',
                    'font-weight': activeStatusFilter === 3 ? '700' : '500',
                    'height': '100%',
                    'box-shadow': activeStatusFilter === 3 ? '0px 1px 2px rgba(0, 0, 134, 0.1)' : 'none'
                 }"
                 (click)="setStatusFilter(3)">
                Missing ({{ statusCounts.missing }})
            </div>
        </div>

        <!-- Search Section -->
        <div class="flex align-items-center gap-2 w-full">
            <div class="vault-search flex-1" style="max-width: 100%;">
                <i class="pi pi-search" style="z-index: 1;"></i>
                <p-autoComplete 
                    [(ngModel)]="searchTitle" 
                    [suggestions]="searchResults" 
                    (completeMethod)="onSearch($event)" 
                    field="title" 
                    placeholder="Search documents by name..."
                    (onSelect)="onSelectSearchResult($event)"
                    styleClass="w-full h-full"
                    [minLength]="2"
                    panelStyleClass="vault-search-panel"
                    inputStyleClass="search-input w-full bg-white"
                    appendTo="body"
                    [inputStyle]="{'border': '1px solid #e5e7eb', 'border-radius': '9px', 'height': '42px', 'padding-left': '40px'}">
                    <ng-template let-doc pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <i class="pi" [ngClass]="doc.docType === 2 ? 'pi-external-link' : 'pi-file-pdf'" style="color: #2e04ac;"></i>
                            <div class="flex flex-column">
                                <span class="font-bold" style="font-size: 14px;">{{doc.title}}</span>
                                <span class="text-xs text-gray-500">{{getCategoryLabel(doc.category)}}</span>
                            </div>
                        </div>
                    </ng-template>
                </p-autoComplete>
            </div>

            <!-- Mobile Sidebar Toggle Icon -->
            <button class="lg:hidden flex align-items-center justify-content-center cursor-pointer transition-colors transition-duration-200"
                    style="width: 42px; height: 42px; background: #000086; border: none; border-radius: 9px; color: white; flex-shrink: 0; box-shadow: 0 4px 6px rgba(0,0,134,0.15);"
                    (click)="mobileSidebarVisible = true">
                <i class="pi pi-filter" style="font-size: 1.1rem;"></i>
            </button>
        </div>
    </div>

    <!-- Accordion Layout -->
    <div class="flex flex-column gap-3 w-full pb-5">
        
        <div class="accordion-item w-full" *ngFor="let section of accordionSections; let i = index">
            <!-- Accordion Header -->
            <div class="flex justify-content-between align-items-center cursor-pointer px-4 py-2 border-round-2xl transition-colors transition-duration-200" 
                 [ngStyle]="{'background-color': '#f8f8fc'}"
                 (click)="toggleSection(section)">
                 
                 <div class="flex align-items-center">
                     <div class="flex align-items-center justify-content-center border-circle mr-3" 
                          style="width: 38px; height: 38px; background-color: #2e04ac; color: #ffffff; font-weight: bold; font-size: 15px;">
                         {{ section.id }}
                     </div>
                     
                     <div class="font-bold flex-1 m-0" style="color: #0b103e; font-size: 18px;">
                         {{ section.title }}
                     </div>
                 </div>
                 
                 <div class="flex align-items-center gap-3">
                     <i class="pi font-bold" style="color: #0b103e; font-size: 18px;" 
                        [ngClass]="section.isOpen ? 'pi-angle-up' : 'pi-angle-down'"></i>
                     
                     <p-button *ngIf="section.filterDocumentId" 
                               icon="pi pi-times" 
                               label="Clear Filter" 
                               styleClass="p-button-text p-button-sm p-button-secondary"
                               (onClick)="$event.stopPropagation(); clearFilter(section)">
                     </p-button>
                 </div>
            </div>
            
            <!-- Accordion Content -->
            <div class="accordion-content-wrapper" [class.open]="section.isOpen">
                <div class="accordion-content-inner">
                    <div class="pt-4 pb-2 px-1">
                
                <!-- Document Cards Grid (Always renders even during loading) -->
                <div class="relative group">
                    <!-- Left Scroll Arrow -->
                    <div class="scroll-nav-btn left-btn" (click)="scrollSection(scrollContainer, 'left')" *ngIf="section.canScrollLeft">
                        <i class="pi pi-chevron-left"></i>
                    </div>

                    <div #scrollContainer [id]="'scroll-container-' + section.id" class="flex decent-scroll w-full p-1" style="scroll-snap-type: x mandatory;" (scroll)="onScroll($event, section)">
                   
                   <!-- Add New Document Card (Appears in each section) -->
                    <div class="flex-shrink-0 p-3" style="scroll-snap-align: start;" *ngIf="activeStatusFilter !== 3">
                        <div class="add-new-card cursor-pointer relative" 
                             style="width: 212px; height: 200px;"
                             (click)="showUploadDialog(section.category)">
                            
                           <div class="rotating-bg"></div>
                            
                           <div class="add-new-card-content flex flex-column align-items-center justify-content-center h-full w-full p-3">
                               <div class="upload-icon-wrapper flex align-items-center justify-content-center border-circle mb-3 transition-transform transition-duration-200" 
                                    style="width: 40px; height: 40px; background-color: #2e04ac;">
                                   <img src="assets/icons/UploadSimple.svg" alt="Upload" style="width: 20px; height: 20px; object-fit: contain; position: relative; top: 2px;" />
                               </div>
                               
                               <h3 class="m-0 mb-3 text-center font-bold" style="color: #0b103e; font-size: 15px; line-height: 1.3;">
                                   Add New<br/>{{ getShortCategoryName(section.category) }}
                               </h3>
                               
                               <div class="flex gap-2 justify-content-center flex-wrap w-full mt-2">
                                   <span class="category-tag transition-colors transition-duration-300">
                                       {{ getCategoryLabel(section.category) }}
                                   </span>
                                   <span class="category-tag transition-colors transition-duration-300">
                                       Upload
                                   </span>
                               </div>
                           </div>
                       </div>
                   </div>

                   <!-- Loading Skeleton Cards -->
                    <ng-container *ngIf="section.isLoading">
                        <div class="flex-shrink-0 p-3" style="scroll-snap-align: start;" *ngFor="let item of skeletonArray">
                            <p-skeleton width="212px" height="200px" borderRadius="18px"></p-skeleton>
                        </div>
                    </ng-container>

                   <!-- Existing Documents -->
                   <ng-container *ngIf="!section.isLoading">
                       <div class="flex-shrink-0 p-3" style="scroll-snap-align: start;" *ngFor="let doc of section.documents; let j = index" [id]="'doc-card-' + doc.id">
                           <app-document-vault-card 
                               [doc]="doc" 
                               (onEdit)="editDocument($event)" 
                               (onDelete)="deleteDocument($event)">
                           </app-document-vault-card>
                       </div>
                       
                        <!-- Pagination Loader -->
                        <div class="flex-shrink-0 p-3" style="scroll-snap-align: start;" *ngIf="section.isFetchingMore">
                            <p-skeleton width="212px" height="200px" borderRadius="18px"></p-skeleton>
                        </div>
                   </ng-container>
                </div>

                <!-- Right Scroll Arrow -->
                <div class="scroll-nav-btn right-btn" (click)="scrollSection(scrollContainer, 'right')" *ngIf="section.canScrollRight">
                    <i class="pi pi-chevron-right"></i>
                </div>
            </div>
        </div>
    </div>
        </div>
    </div>
    </div>
</div>

<!-- Mobile Sidebar Drawer -->
<p-sidebar [(visible)]="mobileSidebarVisible" appendTo="body" position="left" [baseZIndex]="10000" [showCloseIcon]="false" styleClass="p-0 border-round-none custom-mobile-sidebar" [style]="{width: '280px', padding: '0', background: 'transparent', border: 'none', boxShadow: 'none'}">
    <app-document-vault-sidebar #mobileSidebar 
        [isMobileView]="true" 
        [activeCategoryId]="activeCategoryId" 
        [activeStatusFilter]="activeStatusFilter"
        (closeSidebar)="mobileSidebarVisible = false" 
        (onCategorySelect)="handleCategorySelect($event)"
        (onStatusFilterSelect)="setStatusFilter($event)">
    </app-document-vault-sidebar>
</p-sidebar>

<app-document-upload-modal 
    [(visible)]="isModalVisible" 
    (onSaved)="loadDocuments()">
</app-document-upload-modal>
